/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { Form, Input, Table, Select } from 'antd';
import PermissionCodeApi from 'apis/PermissionCodeApi';
import MainLayout from 'components/Modules/Layout/MainLayout';
import useQueryParam from 'hooks/useQueryPrams';
import { useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory, useParams } from 'react-router-dom';
import { calculateColumnsWidth } from 'utils/calculateWidthColumn';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import { HocChangePagination } from 'utils/HocChangePagination';
import { read, utils } from 'xlsx';
import PermissionCodeFilter from 'components/Modules/rating/PermissionCodeFilter';
import queryString from 'query-string';
import { ImportRatingQuery } from 'interface/permissionCode.interface';
import { openNotificationWithIcon } from 'utils/notification';
import handleError401 from 'utils/handleError401';
import * as XLSX from 'xlsx';
import Button from 'components/Button';

export default function PermissionPage(): JSX.Element {
  const history = useHistory();

  const queryParam = useQueryParam();

  const page = parseInt(queryParam.get('page') + '') || 1;

  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const prod_origin_code = queryParam.get('prod_origin_code') || undefined;
  const error_code = queryParam.get('error_code') || undefined;
  const email = queryParam.get('email') || undefined;

  const permissionCodeParams = {
    prod_origin_code,
    error_code,
    email,
  };

  const { mutate: uploadUserStatusRating, isLoading: uploadFileLoading } =
    useMutation(PermissionCodeApi.postImportRating, {
      onSuccess: () => {
        openNotificationWithIcon('success', 'Upload file thành công');
      },
      onError: (error: any) => {
        openNotificationWithIcon('error', 'Upload file thất bại');
        if (error.response.data.status === 401) {
          handleError401();
        }
      },
    });

  const handleImport = (event: any) => {
    const files = event.target.files;
    if (files.length) {
      const file = files[0];
      const reader = new FileReader();
      reader.onload = (event) => {
        const wb = read(event.target?.result);
        const sheets = wb.SheetNames;

        if (sheets.length) {
          const rows = utils.sheet_to_json(
            wb.Sheets[sheets[0]]
          ) as unknown as ImportRatingQuery;
          uploadUserStatusRating(rows);
        }
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const params = JSON.parse(JSON.stringify(permissionCodeParams));

  const { data: PermissionCodeDetail } = useQuery(
    ['getShipmentDetail', permissionCodeParams],
    () => PermissionCodeApi.getPermissionCodeList(params)
  );

  const maxWidthPerCell = 600;
  const tableHeight = 600;
  const rowKey = 'id';
  const dataSource = [] as any;

  const columns: any = [
    {
      title: 'Mã nguồn gốc',
      dataIndex: 'prod_origin_code',
      fixed: 'left',
    },
    {
      title: 'Nguồn gốc',
      dataIndex: 'prod_origin_name',
      fixed: 'left',
    },
    {
      title: 'Mã Lỗi',
      dataIndex: 'error_code',
      width: '150px',
    },
    {
      title: 'Chi tiết mã lỗi',
      dataIndex: 'error_name',
    },
    {
      title: 'Email',
      dataIndex: 'email',
    },
  ];

  const dataTable = calculateColumnsWidth(
    columns,
    dataSource as [],
    maxWidthPerCell
  );

  const onFinish = (values: any) => {
    history.push('/permission-code');
  };

  const handleSearch = (values: any) => {
    const search = queryString.stringify(values);

    history.push({
      pathname: '/permission-code',
      search: `${search}&page=1`,
    });
  };

  function exportExcel(data: any, nameSheet: any, nameFile: any) {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, nameSheet);
    XLSX.writeFile(wb, `${nameFile}.xlsx`);
  }

  return (
    <MainLayout>
      <PermissionCodeFilter handleSearch={handleSearch} />
      <div className="flex flex-row-reverse">
        <label htmlFor="export-file">
          <Button
            onClick={() =>
              exportExcel(
                PermissionCodeDetail?.data,
                'Permission',
                'Danh sách quyền sử dụng mã lỗi'
              )
            }
          >
            <DownloadOutlined />
            Export
          </Button>
        </label>
        <label
          htmlFor="upload-file"
          className="bg-primary-50 opacity-100 rounded-2.5xl text-white para-bold-1 py-2 px-6 drop-shadow-button border-2"
        >
          <UploadOutlined />

          <span className="ml-2 para-2">Import</span>
        </label>

        <input
          type="file"
          onChange={handleImport}
          accept=".xlsx,.xls"
          id="upload-file"
          className="hidden"
        />
      </div>

      <div className="main-content">
        <Table
          scroll={{ x: dataTable.tableWidth, y: tableHeight }}
          columns={columns}
          className="customTable"
          dataSource={PermissionCodeDetail?.data}
          size="small"
          pagination={{
            current: page,
            pageSize: page_size,
            total: PermissionCodeDetail?.total,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            onChange: HocChangePagination(history),
          }}
        />
      </div>
    </MainLayout>
  );
}
